import { AxiosInstance } from "axios"
import { MeetingServiceOrdersResponse } from "../../../merchant/merchant/production/meetingService/meetingServiceApi"
import { TimePeriodMeetingService } from "../../../merchant/merchant/production/meetingService/meetingServiceTypes"
import { ResourceBooking } from "../../../nonAdminUser/reports/upcomingOrders/resourceBookings/userResourceBookingTypes"

export enum ServiceCenterMeetingServiceOrdersQuery {
    MEETING_SERVICE = "meeting-service-orders-for-service-center",
    RESOURCE_BOOKING = "resource-booking-orders-for-service-center",
}

type ServiceCenterMeetingServiceOrdersParams = Readonly<{
    serviceCenterId: number
    startDate: string
    endDate: string
    period?: TimePeriodMeetingService
    deliveryType?: string
}>

export async function fetchMeetingServiceOrders(
    params: ServiceCenterMeetingServiceOrdersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServiceOrdersResponse> {
    const { serviceCenterId, deliveryType, ...rest } = params
    const url = `/serviceCenters/${serviceCenterId}/meetingService`

    const { data } = await axios.get(url, {
        signal,
        params: {
            ...rest,
            ...(deliveryType ? { deliveryType } : {}),
        },
    })

    return data
}

export type FetchServiceCenterResourceBookingResponse = Readonly<{
    orders: ResourceBooking[]
}>

type FetchServiceCenterResourceBookingParams = Readonly<{
    userId: number
    startDate?: string
    endDate?: string
    period?: string
}>

export async function fetchServiceCenterResourceBooking(
    { userId, ...rest }: FetchServiceCenterResourceBookingParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchServiceCenterResourceBookingResponse> {
    const url = `/serviceCenter/${userId}/upcoming/bookings`

    const response = await axios.get(url, {
        params: rest,
        signal,
    })

    return response.data
}

